import { PageItemType } from '@src/api/enums/pageItemType';
import { PageItem as API } from '@src/api/types';
import { PageItem as Data } from '@src/types';

import generateDynamicPageItemAPI from './dynamicPageItemAPI';
import generateDynamicPageItemCover from './dynamicPageItemCover';

const Factory = (api: API): Data => {
  if (api && api.itemType) {
    switch (api.itemType) {
      case PageItemType.API:
        return {
          type: api.itemType,
          data: generateDynamicPageItemAPI(api.api),
        };
      case PageItemType.COVER:
        return {
          type: api.itemType,
          data: generateDynamicPageItemCover(api.cover),
        };
      case PageItemType.CATEGORIES:
        return {
          type: api.itemType,
          data: api.categories,
        };
      default:
        return {
          type: null,
        };
    }
  } else return { type: null };
};

export default Factory;
